// Campus photo for /colleges/seton-hall-university: CC BY 4.0, by Bmzuckerman, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AVictorian_Gothic_-_South_Orange%2C_NJ_-_Seton_Hall_University_(Presidents_Hall)_(2).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/seton-hall-university/; credited under the photo.
const photo = {
    "slug": "seton-hall-university",
    "alt": "Presidents Hall, a Victorian Gothic stone building with a bell tower, on the Seton Hall University campus in South Orange, New Jersey",
    "src": "/colleges/seton-hall-university/campus-1600.webp",
    "srcSmall": "/colleges/seton-hall-university/campus-800.webp",
    "srcMid": "/colleges/seton-hall-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/seton-hall-university/og.jpg",
    "title": "Victorian Gothic - South Orange, NJ - Seton Hall University (Presidents Hall) (2)",
    "author": "Bmzuckerman",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AVictorian_Gothic_-_South_Orange%2C_NJ_-_Seton_Hall_University_(Presidents_Hall)_(2).jpg",
    "read": "2026-10-01"
};

export default photo;
